import React, { useContext } from 'react';
import { GoogleLogin } from 'react-google-login';

import { FaGoogle } from 'react-icons/fa';
import './login.css'

import LoginLayout from '../../layouts/Login/Login';
import Loading from '../../components/Loading';
import LoginContext from '../../context/Login/LoginContext';

const clientId = process.env.REACT_APP_CLIENT_ID_AUTH_GMAIL

const Login = (props) => {
    
    const loginContext = useContext(LoginContext);
    const { login, loading, error, errorEvent } = loginContext;

    return ( 
        <LoginLayout error={error} >   
            {loading ? 
                <Loading /> :                                                     
                <GoogleLogin 
                    clientId={clientId}
                    render={renderProps => { 
                        if(renderProps.disabled){                                                            
                            return <Loading />
                        }else{
                            return (                                                        
                                <button className="btn btn-google btn-user btn-block" onClick={renderProps.onClick} disabled={renderProps.disabled}>
                                    <FaGoogle size={'1em'} style={{'marginRight': '1em'}}/>Login with Google
                                </button>
                                    )
                            }
                    }}
                    buttonText="Login with Mail Idesoft"
                    onSuccess={login}
                    onFailure={errorEvent}
                    cookiePolicy={'single_host_origin'}
                    isSignedIn={true}                
                /> 
                }       
        </LoginLayout>
     );
}
 
export default Login;
